<template>
  <div>
    <div class="header w-1920">
      <div class="img w-1200">
        <img src="../../assets/login/logo.gif" alt="" />
        <div class="home" @click="home">{{ $t('common.home') }}</div>
      </div>
      <div @click="weixin">.</div>
    </div>
    <div class="content w-1920">
      <img src="../../assets/login/nav.png" alt="" />
      <div class="login">
        <div class="login_password">
        <div class="qiehuan">
          <div
            class="daohang"
          >
          {{ $t('common.shortmessage-042') }}
          </div>
        </div>
        <div v-if="TabIndex == 0">
          <div class="user">
            <el-input
              v-model="Register.phone"
              :placeholder="$t('placeholder.Login_PhoneOrName')"
              clearable
            >
              <template slot="prepend">+86</template></el-input
            >
          </div>
          <div class="user-pas">
            <el-form onsubmit="return false">
              <el-form-item :prop="$t('prop.Verification_code')" class="code">
                <el-input
                  v-model="Register.sendcode1"
                  :placeholder="$t('placeholder.shortmessage-044')"
                  @keyup.enter.native="login"
                ></el-input>
                <div class="user-assets-text" v-if="loding">
                  <el-button type="button"><i class="el-icon-loading"></i></el-button>
                </div>
                <div v-else>
                <el-button
                  type="button"
                  @click="sendcode"
                  :disabled="disabled"
                  v-if="disabled == false"
                  >{{ $t('button.Send_verification_code') }}
                </el-button>
                <el-button
                  type="button"
                  @click="sendcode"
                  :disabled="disabled"
                  v-if="disabled == true"
                  >{{ btntxt }}
                </el-button></div>
              </el-form-item></el-form
            >
          </div>
        </div>
        <Loading v-if="isLoading" />
        <div class="denglu" @click="login">{{ $t('button.Confirm') }}</div>
        </div>
      </div>
    </div>
    <Login_bottom />
    <el-button :plain="true" v-show="false"></el-button>
    <el-dialog
  :title="$t('common.Confirmation')"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <span>{{ $t('common.longmessage-017') }}</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">{{ $t('button.Cancel') }}</el-button>
    <el-button type="primary" @click="login_dialog">{{ $t('button.Confirm') }}</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import { post, get } from '@/utils/request';
import { mapMutations } from 'vuex';
import Login_bottom from '@/components/login/login_bottom.vue';
import { setCookie, getCookie, delCookie } from '@/utils/cookie';
import vueQr from 'vue-qr';
export default {
  name: 'Login',
  components: {
    Login_bottom,
    vueQr,
  },
  data() {
    return {
      input: '',
      password: '',
      checked: false,
      isLoading: false,
      TabIndex: 0, // 默认选中Tab
      TabList: [], // Tab数据集合
      Register: {
        sendcode1: '',
        pass: '',
        phone: '',
      },
      disabled: false,
      time: 0,
      btntxt: this.$t('common.resend'),
      uuid: '',
      loding:false,
      dialogVisible: false
    };
  },
  created() {
  },
 
  methods: {
    login_dialog(){
      this.smsWxLogin()
      this.dialogVisible =false
    },
    weixin() {
      get('f/api/wxLogin/qrCodeUrl').then((res)=>{
        window.open(res.data.msg,"_self")
      })
    },
    ...mapMutations(['changeLogin']),
    login() {
      if (this.TabIndex == 0) {
        this.phonelogin();
      }
    },
    // 手机号+短信验证码 登录
    phonelogin() {
      let _this = this;
      post('f/api/wxLogin/smsWxLoginCheck', {
        mobile: this.Register.phone,
        smsCode: this.Register.sendcode1,
        uuid: this.uuid,
      }).then((res) => {
        if(res.data.msg=='false'){
          this.smsWxLogin()
        }else if(res.data.msg=='true'){
          this.dialogVisible = true
        }else{
          this.$message.error({
            message: res.data.msg,
          });
        }
      });
    },
    smsWxLogin(){
      let _this = this;
      post('f/api/wxLogin/smsWxLogin',{
        mobile:this.Register.phone,
        code:this.getQueryVariable('code'),
        state:this.getQueryVariable('state')
      }).then((res)=>{
        _this.userToken = res.data.data.token;
        _this.changeLogin({ Authorization: _this.userToken });
        setCookie('username', res.data.data.username, 7200);
        setCookie('memberId', res.data.data.memberId, 7200);
        setCookie('managerType', res.data.data.managerType, 7200);
        setCookie('companyName', res.data.data.companyName, 7200);
        setTimeout(function() {
          _this.$router.push({name:'Home'});
        }, 600);
        this.$message.success({
          message: this.$t('message.Binding_successful'),
        });
      })
    },
    getQueryVariable(name){
      var search = window.location.search.substring(1)
      if (!search) {
          search = window.location.hash.split('?')[1]
      }
      if (search) {
          var obj = JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
          return name ? obj[name] : obj
      }
    },
    //发送验证码
    sendcode() {
      this.loding = true;
      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.Register.phone == '') {
        this.loding = false;
        this.$message.warning({
          message: this.$t('message.shortmessage-045'),
        });
        return;
      }
      if (!reg.test(this.Register.phone)) {
        this.loding = false;
        this.$message.warning({
          message: this.$t('message.shortmessage-046'),
        });
        return;
      } else {
        get('f/api/wxLogin/smsWxCode?mobile=' + this.Register.phone).then((res) => {
          this.loding = false;
          if (res.data.msg == '0') {
            this.$message.success({
              message: this.$t('message.Sent_successfully'),
            });
            this.uuid = res.data.uuid;
            this.time = 60;
            this.disabled = true;
            this.timer();
          } else if (res.data.msg == '1') {
            this.$message.warning({
              message: this.$t('message.Send_failure'),
            });
          } else {
            this.$message.warning({
              message: this.$t('message.Send_failure'),
            });
          }
        });
      }
    },
    // 发送成功后开启60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + this.$t('common.Reacquire_after');
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = this.$t('button.Get_verification_code');
        this.disabled = false;
      }
    },
    home() {
      this.$router.push({
        name: 'Home',
      });
    },
    handleClose(done) {
        this.$confirm(this.$t('message.confirm.Confirm_closure'))
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },
};
</script>
<style lang="scss" scoped>
.wx_dialog_toiast {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 9854647;
  background: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .wx_dialog_toiast_delltet {
    width: 500px;
    height: 500px;
    background: #606266;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wx_dialog_button_delete {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 100px;
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.code {
  .el-input {
    width: 65%;
    border-radius: 0px;
    float: left;
    display: inline-block;
  }
  .el-button {
    width: 35%;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: 0px;
    float: left;
    display: inline-block;
  }
}
.login_password{
  height: 400px;
}
.qiehuan {
  width: 390px;
  margin: auto;
  margin-top: 30px;
  height: 42px;
  display: flex;
  align-items: center;
  cursor: default;
  font-size: 20px;
  .daohang {
    font-size: 20px;
    color: #272727;
    margin-right: 25px;
    border-bottom: 2px solid #fff;
    cursor: pointer;
    padding-bottom: 3px;
  }
  .bian {
    color: #333;
    border-bottom: 2px solid #333;
  }
}
.header {
  width: 100%;
  height: 130px;
  .img {
    height: 66px;
    padding-top: 50px;
    // padding-left: 264px;
    display: flex;
    align-items: center;
    img {
      width: 230px;
      height: 66px;
    }
    .home {
      font-size: 20px;
      color: #245af2;
      font-weight: 600;
      margin-left: 27px;
      cursor: pointer;
    }
  }
}
.content {
  width: 100%;
  height: 680px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .login {
    width: 495px;
    height: 550px;
    background: #fff;
    position: absolute;
    right: 246px;
    bottom: 0;
    .top-logo {
      position: absolute;
      right: 12px;
      top: 12px;
      .img1 {
        width: 117px;
        height: 25px;
        float: left;
      }
      .img2 {
        width: 50px;
        height: 50px;
        float: left;
        margin-left: 5px;
      }
      .spen {
        font-size: 12px;
        position: absolute;
        left: 15px;
        top: 3px;
        color: #366eff;
      }
    }
    .user {
      width: 390px;
      margin: auto;
      // margin-top: 104px;
      margin-top: 40px;
    }
    .user-pas {
      width: 390px;
      margin: 20px auto;
    }
    .caozuo {
      width: 390px;
      margin: 0 auto;
      .left {
        float: left;
        color: #9a9a9a;
        font-size: 18px;
        display: flex;
        align-items: center;
      }
      .right {
        float: right;
        display: flex;
        justify-content: flex-end;
        .mima {
          color: #9a9a9a;
          margin-left: 11px;
          font-size: 16px;
          cursor: pointer;
        }
        .mima1 {
          color: #9a9a9a;
          margin-left: 11px;
          font-size: 16px;
          cursor: pointer;
        }
        .zhuce {
          color: #fe912a;
          margin-left: 11px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
    .denglu {
      width: 390px;
      height: 55px;
      margin: 0 auto;
      background: #fe912a;
      color: #fff;
      font-size: 22px;
      line-height: 55px;
      display: flex;
      justify-content: center;
      margin-top: 130px;
      border-radius: 5px;
      cursor: pointer;
    }
    .fangzhi {
      width: 100%;
      position: absolute;
      bottom: 30px;
      display: flex;
      justify-content: center;
      .img1 {
        width: 44px;
        height: 44px;
      }
      .img2 {
        width: 44px;
        height: 44px;
      }
      .img3 {
        width: 44px;
        height: 44px;
      }
    }
  }
}
</style>
